import { useCallback } from 'react';
import { useNavigate, useLocation, NavigateOptions } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * A wrapper around useNavigate that automatically prepends the current
 * locale prefix (e.g. /de or /en) to every path-based navigation.
 */
export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      // Don't prefix if it already has a locale prefix
      if (/^\/(en|de)(\/|$)/.test(to)) {
        navigate(to, options);
        return;
      }

      // Prefix with current language
      const prefixed = to === '/' ? `/${language}` : `/${language}${to}`;
      navigate(prefixed, options);
    },
    [navigate, language],
  );
}
